export const GENERATE_QR_CODE = 'GENERATE_QR_CODE';
export const GENERATE_QR_CODE_SUCCESS = 'GENERATE_QR_CODE_SUCCESS';
export const GENERATE_QR_CODE_FAIL = 'GENERATE_QR_CODE_FAIL';
